type ActionButtonsProps = {
  disabledButton?: boolean;
  prevText: string;
  prevAction: () => void;
  nextText: string;
  nextAction: () => void;
};

export const ActionButtons = ({
  disabledButton,
  prevText,
  prevAction,
  nextText,
  nextAction
}: ActionButtonsProps) => {
  return (
    <div className="tw-flex mb:tw-flex-col sm:tw-flex-row tw-justify-between tw-border-t-[0.0625rem] tw-border-t-[#a1a1a1] tw-p-[1.88rem]">
      <button
        className="tw-bg-white tw-border-[1px]  mb:tw-max-w-[100%] tw-border-[#001E64] tw-text-[#001E64] tw-w-full sm:tw-max-w-[9.5rem] tw-px-2.94rem] tw-py-[0.81rem] tw-rounded-[8.34rem]"
        onClick={prevAction}
      >
        {prevText}
      </button>
      <button
        disabled={disabledButton ? disabledButton : false}
        className={`${
          disabledButton
            ? 'tw-bg-[#828282] tw-border-[#828282] tw-cursor-not-allowed'
            : 'tw-bg-[#FF5000] tw-border-[#FF5000] tw-cursor-pointer'
        } tw-border-[1px] mb:tw-max-w-[100%] mb:tw-mt-3 sm:tw-mt-0  tw-text-white tw-w-full sm:tw-max-w-[9.5rem] tw-px-2.94rem] tw-py-[0.81rem] tw-rounded-[8.34rem] `}
        onClick={nextAction}
      >
        {nextText}
      </button>
    </div>
  );
};
